import { IGetValueArgs } from "@components/smart/FieldInfo";
import { ICompanyEntity } from "@odata/GeneratedEntityTypes";
import { ModuleCode } from "@odata/GeneratedEnums";

export const isNewEntity = (args: IGetValueArgs): boolean => {
    return args.storage.data.bindingContext.isNew();
};

export function isModuleEnabledOnCompany(company: ICompanyEntity, moduleCode: ModuleCode): boolean {
    return !!company?.Modules?.find(module => module.ModuleCode === moduleCode)?.IsEnabled;
}

export function isPayrollEnabledOnCompany(company: ICompanyEntity): boolean {
    return !!company?.Modules?.find(module => module.ModuleCode === ModuleCode.Payroll)?.IsEnabled;
}

export function isGrantEnabledOnCompany(company: ICompanyEntity): boolean {
    return isModuleEnabledOnCompany(company, ModuleCode.Grants);
}

export const isPayrollEnabledOnTenantLevel = (args: IGetValueArgs): boolean => {
    const { companies } = args.context.getData() ?? {};
    return companies?.some(isPayrollEnabledOnCompany);
};

export const isPayrollEnabledOnCurrentCompany = (args: IGetValueArgs): boolean => {
    const company = args.context.getCompany() ?? {};
    return isPayrollEnabledOnCompany(company);
};